import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { getOrigin } from "../../http/api/MasterAPI";
import { getProduct } from "../../http/api/ProductAPI";
import { convertToHiragana } from "../../utils/convertToHalfWidthKana";
import CommonAutocomplete from "../../components/CommonAutocomplete";
import SALES_RECORD_TYPE from "../../utils/variable";
import { getCommodityOwner } from "../../http/api/CommodityOwnerAPI";
import { fromKana } from "hepburn";
import { getNextSalesRecordNo } from "../../http/api/SalesRecordAPI";
import { delay, getHyphenedDate } from "../../utils/utils";

const LOCAL_SHORT_CUT = {
  arrivalDate: 0,
  deliveryDate: 1,
  salesRecordNo: 2,
  commodityOwnerCd: 3,
  productId: 4,
  // acceptanceEmployeeId: 5,
  containerQuantity: 5,
  seriEmployeeId: 6,
  // originId: 7,
  // modificationDate: 7,
  feeRate: 7,
  shippingFee: 8,
  salesRecordProcessDivisionCd: 9,
};

const TRAVEL_SHORT_CUT = {
  arrivalDate: 0,
  deliveryDate: 1,
  salesRecordNo: 2,
  commodityOwnerCd: 3,
  productId: 4,
  acceptanceEmployeeId: 5,
  // containerQuantity: 6,
  // seriEmployeeId: 7,
  acceptanceLabelNo: 6,
  partition: 7,
  originId: 8,
  directorEmployeeId: 9,
  // modificationDate: 10,
  feeRate: 10,
  shippingFee: 11,
  salesRecordProcessDivisionCd: 12,
};

export default function Header(props) {
  const {
    apiSalesRecord,
    insertedInvoice,
    salesRecord,
    salesDetails,
    getSalesRecordByNo,
    setting,
    renderState,
    changeHistoryItem,
    changeHistoryItemsWithArray,
    setHistoryItems
  } = props;
  const HEADER_ELEMENT_COUNT = 17;
  const { salesRecordType, invoiceIsDisabled } = setting.Value;
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState({});
  const [origins, setOrigins] = useState([]);
  const [origin, setOrigin] = useState({});
  const [commodityOwners, setCommodityOwners] = useState([]);
  const [commodityOwner, setCommodityOwner] = useState({});
  const today = getHyphenedDate();

  async function GetProduct() {
    try {
      let response = await getProduct({});
      let listProduct = response.listProductInfo;
      listProduct = listProduct
        .filter((x) => x.productKana != null && x.productName != null)
        .map((p) => ({
          ...p,
          productNameHira: convertToHiragana(p.productKana),
          productNameRomanji: fromKana(p.productKana),
        }))
        .sort((a, b) => a.productId - b.productId);
      setProducts(listProduct);
      console.log("商品リスト取得");
    } catch (e) {
      console.log("商品リストを取得する際にエラー発生した：", e);
    }
  }
  async function GetOrigin() {
    try {
      let response = await getOrigin({});
      let listOrigin = response.masterVarInfo;
      listOrigin = listOrigin
        .map((o) => ({
          originId: o.varCd,
          originName: o.varValue1,
        }))
        .sort((a, b) => a.originId - b.originId);
      setOrigins(listOrigin);
      console.log("産地リスト取得");
    } catch (e) {
      console.log("産地リストを取得する際にエラー発生した：", e);
    }
  }
  async function GetCommodityOwner() {
    try {
      let response = await getCommodityOwner({});
      let listCommodityOwner = response.listCommodityOwnerInfo.sort(
        (a, b) => a.commodityOwnerCd - b.commodityOwnerCd
      );
      setCommodityOwners(listCommodityOwner);
      console.log("荷主リスト取得");
    } catch (e) {
      console.log("荷主リストを取得する際にエラー発生した：", e);
    }
  }
  useEffect(() => {
    GetProduct();
    GetOrigin();
    GetCommodityOwner();
  }, []);

  useEffect(() => {
    salesRecord.update("productId", product?.productId || "");
  }, [product]);
  useEffect(() => {
    salesRecord.update("originId", origin?.originId || "");
  }, [origin]);

  useEffect(() => {
    setProduct(products.find((x) => x.productId === apiSalesRecord.productId));
    setOrigin(origins.find((x) => x.originId === apiSalesRecord.originId));
    setCommodityOwner(
      commodityOwners.find(
        (x) => x.commodityOwnerCd === apiSalesRecord.commodityOwnerCd
      )
    );
    renderState.update("salesRecord", true);
  }, [apiSalesRecord]);

  useEffect(() => {
    salesRecord.update("depositFee", salesRecord.Value.containerQuantity * 10);
  }, [salesRecord.Value.containerQuantity]);

  async function handlePressKey(event) {
    if (event.key === "Enter") {
      if (invoiceIsDisabled) {
        document.activeElement.blur();
        await delay(1000);
      }
      // 左Enter
      if (event.location === 0) {
        event.preventDefault();
        const nextElementId =
          salesRecordType === SALES_RECORD_TYPE.STOCK
            ? "salesResults-0-0"
            : `salesDetail-0-0`;
        let nextElement = document.getElementById(nextElementId);
        if (nextElement) nextElement.focus();
      }
      // 右Enter
      if (event.location === 3) {
        event.preventDefault();
        //在庫販売原票に右Enterを押したら実績に転移する
        if(salesRecordType === SALES_RECORD_TYPE.STOCK){
          let nextElement = document.getElementById("salesResults-0-0");
          if (nextElement) nextElement.focus();
        }
        focusNavigation(event.target, event.shiftKey);
      }
    }
  }

  async function handleKeyDown(event) {
    const keyCode = event.keyCode;
    //Arrow Key
    if (keyCode === 37) {
      // Handle left arrow key press
      focusNavigation(event.target, true);
    } else if (keyCode === 38) {
      // Handle up arrow key press
    } else if (keyCode === 39) {
      // Handle right arrow key press
      focusNavigation(event.target, false);
    }

    //過去に登録した販売原票データをコピーする
    //Pressed ESC
    if (keyCode === 27) {
      event.preventDefault();
      const previousHeader = insertedInvoice.Value.salesRecordInfo;
      const targetId = event.target.id;
      const salesRecordNoId = `header-${
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? LOCAL_SHORT_CUT.salesRecordNo
          : TRAVEL_SHORT_CUT.salesRecordNo
      }`;
      const commodityOwnerElementId = `header-${
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? LOCAL_SHORT_CUT.commodityOwnerCd
          : TRAVEL_SHORT_CUT.commodityOwnerCd
      }`;
      const productElementId = `header-${
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? LOCAL_SHORT_CUT.productId
          : TRAVEL_SHORT_CUT.productId
      }`;
      const acceptanceEmployeeElementId = `header-${
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? LOCAL_SHORT_CUT.acceptanceEmployeeId
          : TRAVEL_SHORT_CUT.acceptanceEmployeeId
      }`;
      const acceptanceLabelElementId = `header-${
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? LOCAL_SHORT_CUT.acceptanceLabelNo
          : TRAVEL_SHORT_CUT.acceptanceLabelNo
      }`;
      const originElementId = `header-${
        salesRecordType === SALES_RECORD_TYPE.LOCAL
          ? LOCAL_SHORT_CUT.originId
          : TRAVEL_SHORT_CUT.originId
      }`;
      if (targetId === commodityOwnerElementId) {
        let commodityOwner = commodityOwners.find(
          (x) => x.commodityOwnerCd === previousHeader.commodityOwnerCd
        );
        salesRecord.update("commodityOwnerCd", previousHeader.commodityOwnerCd);
        salesRecord.update("feeRate", commodityOwner?.feeRate);
        setCommodityOwner(commodityOwner);
        changeHistoryItemsWithArray([
          {itemName: "header-0-commodityOwnerCd", value: previousHeader.commodityOwnerCd, valueName: commodityOwner?.commodityOwnerName},
          {itemName: "header-0-feeRate", value: commodityOwner?.feeRate, valueName: null},
        ])
      }
      if (targetId === productElementId) {
        const selectedProduct = products.find((x) => x.productId === previousHeader.productId);
        setProduct(selectedProduct);
        changeHistoryItem('header-0-productId', previousHeader.productId, selectedProduct?.productName);
      }
      if (targetId === acceptanceEmployeeElementId) {
        salesRecord.update(
          "acceptanceEmployeeId",
          previousHeader.acceptanceEmployeeId
        );
      }
      if (targetId === acceptanceLabelElementId) {
        salesRecord.update(
          "acceptanceLabelNo",
          previousHeader.acceptanceLabelNo
        );
        changeHistoryItem('header-0-acceptanceLabelNo', previousHeader.acceptanceLabelNo);
      }
      if (targetId === originElementId) {
        const selectedOrigin = origins.find((x) => x.originId === previousHeader.originId);
        setOrigin(selectedOrigin);
        changeHistoryItem('header-0-originId', previousHeader.originId, selectedOrigin?.originName);
      }
      if (targetId === salesRecordNoId && salesRecordType === SALES_RECORD_TYPE.TRAVEL) {
        getNextSalesRecordNo().then((newSalesRecordNo) => {
          salesRecord.update("salesRecordNo", newSalesRecordNo);
          changeHistoryItem('header-0-salesRecordNo', newSalesRecordNo);
        });
      }
      focusNavigation(event.target, false);
    }
  }

  function focusNavigation(currentElement, isPrevious = false) {
    const focusing = currentElement.id;
    const nextStep = isPrevious ? -1 : 1;
    const nextIndex = parseInt(focusing.split("-")[1], 10) + nextStep;
    const district =
      nextIndex < HEADER_ELEMENT_COUNT ? "header" : "salesDetail";
    let shortcut = {
      district: district,
      index: nextIndex < HEADER_ELEMENT_COUNT ? nextIndex : "0-0",
    };
    setTimeout(() => {
      let nextElement = document.getElementById(
        `${shortcut.district}-${shortcut.index}`
      );
      if (nextElement) {
        nextElement.focus();
      } else {
      }
    }, 0);
  }

  function handleFocus(event) {
    event.target.select();
  }

  async function handleBlur(event) {
    const blurredId = event.target.id;
    if (blurredId == "header-2") {
      const invoice = await getSalesRecordByNo(salesRecord, salesRecordType);
      if (invoice) {
        setHistoryItems([
          {itemName: "header-0-arrivalDate", value: salesRecord.Value.arrivalDate},
          {itemName: "header-0-deliveryDate", value: salesRecord.Value.deliveryDate}
        ]);
      }
      else if (salesRecord.Value.salesRecordNo) {
        setHistoryItems([
          {itemName: "header-0-arrivalDate", value: salesRecord.Value.arrivalDate},
          {itemName: "header-0-deliveryDate", value: salesRecord.Value.deliveryDate},
          {itemName: "header-0-salesRecordNo", value: salesRecord.Value.salesRecordNo}
        ])
      } 
    }
  }

  return (
    <Box
      onKeyPress={handlePressKey}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <Grid>
        <Grid xs={4}>
          <Typography display="flex" justifyContent="center" fontSize={30}>
            {salesRecordType === SALES_RECORD_TYPE.LOCAL && "（地）"}
            {salesRecordType === SALES_RECORD_TYPE.TRAVEL && "（旅）"}
            {salesRecordType === SALES_RECORD_TYPE.STOCK && "（在）"}
            販売原票エントリ
          </Typography>
        </Grid>
        <Grid xs={4} display="flex" justifyContent="space-between">
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              inputProps: {
                min: invoiceIsDisabled ? "1000-01-01" : today,
                max: "9999-12-31",
              },
              ...props.InputProps,
            }}
            label="売立日付"
            type="date"
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.arrivalDate
                : TRAVEL_SHORT_CUT.arrivalDate
            }`}
            // value={new Date().toISOString().substring(0, 10)}
            value={salesRecord.Value.arrivalDate}
            onChange={(e) => {
              salesRecord.update("arrivalDate", e.target.value);
              changeHistoryItem('header-0-arrivalDate', e.target.value);
            }}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
            }
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              inputProps: {
                min: "1000-01-01",
                max: "9999-12-31",
              },
              ...props.InputProps,
            }}
            label="入荷日付"
            type="date"
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.deliveryDate
                : TRAVEL_SHORT_CUT.deliveryDate
            }`}
            index="header-1"
            // value={new Date().toISOString().substring(0, 10)}
            value={salesRecord.Value.deliveryDate.substring(0, 10)}
            onChange={(e) => {
              salesRecord.update("deliveryDate", e.target.value);
              changeHistoryItem('header-0-deliveryDate', e.target.value);
            }}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
            }
          ></TextField>
        </Grid>
      </Grid>

      {/* 1 */}
      <Grid container my={3}>
        <Grid item xs={12} justifyContent="space-between" display={"flex"}>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="原票No"
            sx={{ maxWidth: 300 }}
            value={salesRecord.Value.salesRecordNo}
            onChange={(e) =>
              salesRecord.update("salesRecordNo", e.target.value)
            }
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.salesRecordNo
                : TRAVEL_SHORT_CUT.salesRecordNo
            }`}
            index="header-2"
          ></TextField>
          <Box sx={{ maxWidth: 350 }} display="flex" flexDirection="column">
            <CommonAutocomplete
              label="荷主"
              value={commodityOwner}
              onSelect={(e, newValue) => {
                salesRecord.update(
                  "commodityOwnerCd",
                  newValue.commodityOwnerCd
                );
                salesRecord.update("feeRate", newValue.feeRate);
                changeHistoryItemsWithArray([
                  {itemName: "header-0-commodityOwnerCd", value: newValue.commodityOwnerCd, valueName: newValue.commodityOwnerName},
                  {itemName: "header-0-feeRate", value: newValue.feeRate, valueName: null},
                  {itemName: "header-0-shippingFee", value: 0, valueName: null},
                ]);
                setCommodityOwner(newValue);
                focusNavigation(document.activeElement, false);
              }}
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.commodityOwnerCd
                  : TRAVEL_SHORT_CUT.commodityOwnerCd
              }`}
              data={commodityOwners}
              filterOptions={(options, { inputValue }) => {
                inputValue = inputValue.trim();
                return options.filter(
                  (x) =>
                    x.commodityOwnerCd.toString().startsWith(inputValue) ||
                    x.commodityOwnerName.includes(inputValue)
                );
              }}
              optionLabel={(option) =>
                option
                  ? option.commodityOwnerCd + " - " + option.commodityOwnerName
                  : ""
              }
              width={300}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            />
          </Box>
          <Box sx={{ maxWidth: 250 }} display="flex" flexDirection="column">
            <CommonAutocomplete
              label="品名"
              value={product}
              onSelect={(e, newValue) => {
                setProduct(newValue);
                focusNavigation(document.activeElement, false);
                changeHistoryItem('header-0-productId', newValue?.productId || '', newValue?.productName || null);
              }}
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.productId
                  : TRAVEL_SHORT_CUT.productId
              }`}
              data={products}
              filterOptions={(options, { inputValue }) => {
                inputValue = fromKana(inputValue.toUpperCase());
                return options.filter(
                  (x) =>
                    x.productId.toString().startsWith(inputValue) ||
                    x.productName.includes(inputValue) ||
                    x.productNameRomanji.includes(inputValue)
                );
              }}
              optionLabel={(option) =>
                option ? option.productId + " - " + option.productName : ""
              }
              width={200}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            />
          </Box>
          {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
            <TextField
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: 20,
                  fontWeight: 500,
                  padding: 0,
                },
              }}
              InputProps={{
                paddingInline: 0,
                ...props.InputProps,
              }}
              label="荷受"
              sx={{ width: 100 }}
              value={salesRecord.Value.acceptanceEmployeeId || ""}
              onChange={(e) => {
                salesRecord.update("acceptanceEmployeeId", e.target.value);
                changeHistoryItem('header-0-acceptanceEmployeeId', e.target.value);
              }}
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.acceptanceEmployeeId
                  : TRAVEL_SHORT_CUT.acceptanceEmployeeId
              }`}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            ></TextField>
          )}
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="コンテナ数"
            sx={{ width: 100 }}
            value={salesRecord.Value.containerQuantity}
            onChange={(e) => {
              salesRecord.update("containerQuantity", e.target.value);
              changeHistoryItem('header-0-containerQuantity', e.target.value);
            }}
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.containerQuantity
                : TRAVEL_SHORT_CUT.containerQuantity
            }`}
            disabled={
              salesRecordType !== SALES_RECORD_TYPE.LOCAL || invoiceIsDisabled
            }
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="セリ"
            sx={{ width: 100 }}
            value={salesRecord.Value.seriEmployeeId || ""}
            onChange={(e) => {
              salesRecord.update("seriEmployeeId", e.target.value);
              changeHistoryItem('header-0-seriEmployeeId', e.target.value);
            }}
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.seriEmployeeId
                : TRAVEL_SHORT_CUT.seriEmployeeId
            }`}
            disabled={
              salesRecordType !== SALES_RECORD_TYPE.LOCAL || invoiceIsDisabled
            }
          ></TextField>

          {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
            <TextField
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: 20,
                  fontWeight: 500,
                  padding: 0,
                },
              }}
              InputProps={{
                paddingInline: 0,
                ...props.InputProps,
              }}
              label="送り状No"
              sx={{ maxWidth: 350 }}
              value={salesRecord.Value.acceptanceLabelNo || ""}
              onChange={(e) => {
                salesRecord.update("acceptanceLabelNo", e.target.value);
                changeHistoryItem('header-0-acceptanceLabelNo', e.target.value);
              }}
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.acceptanceLabelNo
                  : TRAVEL_SHORT_CUT.acceptanceLabelNo
              }`}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            ></TextField>
          )}

          {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
            <TextField
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: 20,
                  fontWeight: 500,
                  padding: 0,
                },
              }}
              InputProps={{
                paddingInline: 0,
                ...props.InputProps,
              }}
              label="仕切"
              sx={{ width: 100 }}
              value={salesRecord.Value.partition || ""}
              onChange={(e) => {
                salesRecord.update("partition", e.target.value);
                changeHistoryItem('header-0-partition', e.target.value);
              }}
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.partition
                  : TRAVEL_SHORT_CUT.partition
              }`}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            ></TextField>
          )}
          <CommonAutocomplete
            label="産地"
            value={origin}
            onSelect={(e, newValue) => {
              setOrigin(newValue);
              focusNavigation(document.activeElement, false);
              changeHistoryItem('header-0-originId', newValue?.originId || null, newValue?.originName || null);
            }}
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.originId
                : TRAVEL_SHORT_CUT.originId
            }`}
            data={origins}
            filterOptions={(options, { inputValue }) => {
              inputValue = inputValue.trim();
              return options.filter((x) => {
                return (
                  x.originId.toString().startsWith(inputValue) ||
                  x.originName.includes(inputValue)
                );
              });
            }}
            optionLabel={(option) =>
              option ? option.originId + " - " + option.originName : ""
            }
            width={200}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.LOCAL ||
              salesRecordType === SALES_RECORD_TYPE.STOCK ||
              invoiceIsDisabled
            }
          />

          {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
            <TextField
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: 20,
                  fontWeight: 500,
                  padding: 0,
                },
              }}
              InputProps={{
                paddingInline: 0,
                ...props.InputProps,
              }}
              label="荷印"
              sx={{ width: 100 }}
              value={salesRecord.Value.commodityMark || ""}
              disabled
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.commodityMark
                  : TRAVEL_SHORT_CUT.commodityMark
              }`}
            ></TextField>
          )}

          {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
            <TextField
              InputLabelProps={{
                shrink: true,
                style: {
                  fontSize: 20,
                  fontWeight: 500,
                  padding: 0,
                },
              }}
              InputProps={{
                paddingInline: 0,
                ...props.InputProps,
              }}
              label="担当"
              sx={{ width: 100 }}
              value={salesRecord.Value.directorEmployeeId || ""}
              onChange={(e) => {
                salesRecord.update("directorEmployeeId", e.target.value);
                changeHistoryItem("header-0-directorEmployeeId", e.target.value);
              }}
              id={`header-${
                salesRecordType === SALES_RECORD_TYPE.LOCAL
                  ? LOCAL_SHORT_CUT.directorEmployeeId
                  : TRAVEL_SHORT_CUT.directorEmployeeId
              }`}
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            ></TextField>
          )}
        </Grid>
      </Grid>

      {/* 2 */}

      <Grid container my={3}>
        <Grid item xs={12} justifyContent="start" display={"flex"}>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="手数料"
            sx={{ maxWidth: 300 }}
            value={salesRecord.Value.feeRate}
            onChange={(e) => {
              salesRecord.update("feeRate", e.target.value);
              changeHistoryItem("header-0-feeRate", e.target.value);
            }}
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.feeRate
                : TRAVEL_SHORT_CUT.feeRate
            }`}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
            }
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="運賃"
            sx={{ maxWidth: 300 }}
            value={salesRecord.Value.shippingFee}
            onChange={(e) => {
              salesRecord.update("shippingFee", e.target.value);
              changeHistoryItem("header-0-shippingFee", e.target.value);
            }}
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.shippingFee
                : TRAVEL_SHORT_CUT.shippingFee
            }`}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
            }
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="預り金"
            sx={{ maxWidth: 120 }}
            value={salesRecord.Value.depositFee}
            // onChange={(e) => salesRecord.update("depositFee", e.target.value)}
            disabled
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="その他"
            sx={{ width: 120 }}
            value={salesRecord.Value.salesRecordProcessDivisionCd}
            onChange={(e) => {
              salesRecord.update("salesRecordProcessDivisionCd", e.target.value);
              changeHistoryItem("header-0-salesRecordProcessDivisionCd", e.target.value);
            }}
            id={`header-${
              salesRecordType === SALES_RECORD_TYPE.LOCAL
                ? LOCAL_SHORT_CUT.salesRecordProcessDivisionCd
                : TRAVEL_SHORT_CUT.salesRecordProcessDivisionCd
            }`}
            disabled={
              salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
            }
          ></TextField>
          <TextField
            InputLabelProps={{
              shrink: true,
              style: {
                fontSize: 20,
                fontWeight: 500,
                padding: 0,
              },
            }}
            InputProps={{
              paddingInline: 0,
              ...props.InputProps,
            }}
            label="合計数量"
            sx={{ width: 120 }}
            value={salesDetails.Value.reduce(
              (total, item) => total + (parseInt(item.quantity) || 0),
              0
            )}
            disabled
          ></TextField>
          {salesRecordType !== SALES_RECORD_TYPE.TRAVEL ? null : (
            <FormControlLabel
              label="明細ごとに原票を分ける"
              sx={{ marginLeft: 1 }}
              control={
                <Checkbox
                  checked={salesRecord.Value.needsPrintForEachDetail}
                  onChange={(e) =>
                    salesRecord.update(
                      "needsPrintForEachDetail",
                      e.target.checked
                    )
                  }
                />
              }
              disabled={
                salesRecordType === SALES_RECORD_TYPE.STOCK || invoiceIsDisabled
              }
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
